import React, { useEffect, useState } from 'react';
import { Container, SectionProjeto, ThisButton, ThisCard, ThisCardItem, ThisProgress, ScrollOS } from './styles';
import * as XLSX from 'xlsx-color';

import { Select, Input } from "~/componentes/CustomForm";

import IconCircleRel from '~/assets/icones/IconCircleRel.svg';
import IconCircleRelB from '~/assets/icones/IconCircleRelB.svg';
import IconProjData from '~/assets/icones/IconProjData.svg';
import IconProjTempo from '~/assets/icones/IconProjTempo.svg';
import IconProjCoord from '~/assets/icones/IconProjCoord.svg';
import IconProjEtapa from '~/assets/icones/IconProjEtapa.svg';
import IconProjDataB from '~/assets/icones/IconProjDataB.svg';
import IconProjTempoB from '~/assets/icones/IconProjTempoB.svg';
import IconProjCoordB from '~/assets/icones/IconProjCoordB.svg';
import IconProjEtapaB from '~/assets/icones/IconProjEtapaB.svg';
import IconProjeto from '~/assets/icones/IconProjeto.svg';
import IconExcel from "~/assets/icones/IconExcel.svg";
import IconExcelB from "~/assets/icones/IconExcelB.svg";

function CustomBodyContent({ data, clientes, idCliente, setIdCliente, coordenadores, idCoordenador, setIdCoordenador, idsEtapa, setIdsEtapa, titulo, setTitulo }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);
  const [dadosAlerta, setDadosAlerta] = useState([]);
  const [dados, setDados] = useState([]);
  const [dadosAbertos, setDadosAbertos] = useState([]);
  const [geraExcel, setGeraExcel] = useState(false);
  const [geraSintAnal, setGeraSintAnal] = useState("S");

  useEffect(() => {
    if (data[0]?.projetos) {
      let lista = [];
      let listaAlerta = [];
      for (const item of data[0]?.projetos) {
        let findIndex = dadosAbertos.findIndex((e) => e?.id == item?.id);

        let listaAtividades = [];
        for (const itemAtiv of item?.atividades) {
          listaAtividades.push({
            ...itemAtiv,
            status: item?.idEtapa != 11 && item?.dataEntrega == null ? itemAtiv?.diasAtraso > 0 ? "Estourado" : (itemAtiv?.diasAtraso >= -10) ? "Alerta" : "Normal" : "Finalizado",
          });
        }

        lista.push({
          ...item,
          atividades: listaAtividades,
          aberto: findIndex < 0 ? false : true,
          status: item?.idEtapa != 11 ? item?.diasAtraso > 0 ? "Estourado" : (item?.diasAtraso >= -10) ? "Alerta" : "Normal" : "Finalizado",
        });
      }

      setDados(lista);
      setDadosAlerta(listaAlerta);
    }
  }, [data]);

  useEffect(() => {
    if (data && data?.length && geraExcel) {
      let lista = [];

      if (geraSintAnal == "S") {
        lista.push([
          "Status",
          "Id Projeto",
          "Titulo",
          "Cliente",
          "Coordenador",
          "Previsão de Inicio",
          "Previsão de Entrega",
          "Etapa",
          "Horas Total",
          "Horas Saldo",
          "Horas Usado",
          "%",
          "Dias Atraso",
          "Alt. Prev Entrega",
        ]);
      } else {
        lista.push([
          "Status",
          "Id Projeto",
          "Titulo",
          "Cliente",
          "Coordenador",
          "Atividade",
          "Previsão de Inicio",
          "Previsão de Entrega",
          "Etapa",
          "Horas Total",
          "Horas Saldo",
          "Horas Usado",
          "%",
          "Dias Atraso",
          "Alt. Prev Entrega",
        ]);
      }

      for (const item of dados) {
        if (geraSintAnal == "S") {
          lista.push([
            item?.status,
            item?.id,
            item?.titulo,
            item?.cliente?.nomeFantasia,
            item?.coordenador?.nome,
            ((new Date(item?.previsaoInicio).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0],
            ((new Date(item?.previsaoEntrega).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0],
            item?.etapa?.titulo,
            item?.horaTotalMascara,
            item?.horaSaldoMascara,
            item?.horaUsadaMascara,
            (((item?.horaUsada * 100) / item?.horaTotal).toFixed(2)).toString().replace(".", ","),
            item?.diasAtraso,
            item?.quantHist,
          ]);
        } else {
          for (const itemAtv of item?.atividades) {
            lista.push([
              item?.status,
              item?.id,
              item?.cliente?.nomeFantasia,
              item?.coordenador?.nome,
              item?.etapa?.titulo,
              item?.titulo,
              itemAtv?.titulo,
              ((new Date(itemAtv?.previsaoInicio).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0],
              ((new Date(itemAtv?.previsaoEntrega).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0],
              itemAtv?.horaTotalMascara,
              itemAtv?.horaSaldoMascara,
              itemAtv?.horaUsadaMascara,
              (((itemAtv?.horaUsada * 100) / itemAtv?.horaTotal).toFixed(2)).toString().replace(".", ","),
              itemAtv?.diasAtraso,
              itemAtv?.historicos?.length,
            ]);
          }
        }
      }

      let sheets = {
        "Projetos": lista
      }

      const workbook = XLSX.utils.book_new();
      for (let sheet of Object.keys(sheets)) {
        XLSX.utils.book_append_sheet(
          workbook,
          XLSX.utils.aoa_to_sheet(sheets[sheet]),
          sheet
        );
      }

      // const worksheet = XLSX.utils.json_to_sheet(lista);
      // XLSX.utils.book_append_sheet(workbook, worksheet, "Projetos");

      let i;
      for (i = 1; i <= sheets["Projetos"]?.length; i++) {
        let status = sheets["Projetos"][i - 1][0];
        console.log(status);

        let cor = "FFFFFF";
        if (status == "Finalizado" || status == "Normal") {
          cor = "339C89";
        }

        if (status == "Estourado") {
          cor = "ff7676";
        }

        if (status == "Alerta") {
          cor = "b6b112";
        }

        workbook.Sheets["Projetos"]["A" + i].s = {
          fill: {
            patternType: "solid",
            fgColor: {
              rgb: cor,
            }
          }
        };
      }
      XLSX.writeFile(workbook, "Projetos" + (new Date().toLocaleString('pt-BR', { timeZone: 'UTC' })) + ".xlsx");
      setGeraExcel(false);
    }
  }, [geraExcel]);

  return (
    <Container>
      <div className="header-content">
        <div className="div-icone">
          <img src={IconProjeto} alt={"IconProjeto"} />
          <h4 className="title">Projetos</h4>
        </div>
        <div className="div-filtro">
          <div className="item">
            <Select
              isString
              list={{ list: [{ id: "S", nome: "Sintético" }, { id: "A", nome: "Analítico" }], value: "id", label: "nome" }}
              name="idTipoRel"
              onChange={(e) => {
                setGeraSintAnal(e?.currentTarget?.value);
              }}
            />
          </div>
          <div className="item">
            <button className="btn-excel" onClick={() => setGeraExcel(true)}>
              <img src={localStorage.getItem("tema") == "E" ? IconExcel : IconExcelB} alt="Icone de Excel" />
            </button>
          </div>
          <div className="item">
            <Input
              name="titulo"
              defaultValue={titulo}
              onBlur={(e) => {
                setTitulo(e?.currentTarget?.value);
              }}
            />
          </div>
          <div className="item">
            <Select
              isString
              list={{ list: clientes, value: "id", label: "nomeFantasia" }}
              name="idContrato"
              firstOption="Todas os Clientes"
              defaultValue={idCliente}
              onChange={(e) => {
                setIdCliente(e?.currentTarget?.value);
              }}
            />
          </div>
          <div className="item">
            <Select
              isString
              list={{ list: coordenadores, value: "id", label: "nome" }}
              name="idCoordenadores"
              firstOption="Todos os Coordenadores"
              defaultValue={idCoordenador}
              onChange={(e) => {
                setIdCoordenador(e?.currentTarget?.value);
              }}
            />
          </div>
        </div>
      </div>
      <div className="content-oc">
        <ScrollOS>
          <div className="sessao-quantidade">
            {data[0]?.etapas?.map((thisData, i) => (
              <div
                className={idsEtapa.find((e) => e == thisData?.id) || (idsEtapa.length == 0 && thisData?.id == null) ? "item-quantidade ativo" : "item-quantidade"}
                onClick={(e) => {
                  let lista = [];
                  let count = 0;
                  for (const item of idsEtapa) {
                    if (item == thisData?.id) {
                      count++;
                    } else {
                      lista.push(item);
                    }
                  }

                  if (count == 0) {
                    lista.push(thisData?.id);
                  }

                  if (thisData?.id == null) {
                    lista = [];
                  }

                  setIdsEtapa(lista);
                }}
              >
                <div className='item-left'>
                  {
                    i % 5 == 0 ? (
                      <h5 className='pre-titulo-body color5'>Projetos</h5>
                    ) : i % 4 == 0 ? (
                      <h5 className='pre-titulo-body color4'>Projetos</h5>
                    ) : i % 3 == 0 ? (
                      <h5 className='pre-titulo-body color3'>Projetos</h5>
                    ) : i % 2 == 0 ? (
                      <h5 className='pre-titulo-body color2'>Projetos</h5>
                    ) : i % 1 == 0 ? (
                      <h5 className='pre-titulo-body color1'>Projetos</h5>
                    ) : (<h5></h5>)
                  }
                  <h5 className='titulo-body'>{thisData?.titulo}</h5>
                </div>
                <div className='item-right'>
                  <div className='item-numero'>
                    <img src={localStorage.getItem("tema") == "E" ? IconCircleRel : IconCircleRelB} alt="IconCircleRel" />
                    {
                      i % 5 == 0 ? (
                        <h5 className='color5'>{thisData?.quantidade}</h5>
                      ) : i % 4 == 0 ? (
                        <h5 className='color4'>{thisData?.quantidade}</h5>
                      ) : i % 3 == 0 ? (
                        <h5 className='color3'>{thisData?.quantidade}</h5>
                      ) : i % 2 == 0 ? (
                        <h5 className='color2'>{thisData?.quantidade}</h5>
                      ) : i % 1 == 0 ? (
                        <h5 className='color1'>{thisData?.quantidade}</h5>
                      ) : (<h5></h5>)
                    }
                  </div>
                </div>
              </div>
            ))}
          </div>
          <SectionProjeto>
            {dados?.map((thisProjeto, i) => (
              <ThisCard>
                <div
                  className='card-item'
                  onClick={() => {
                    let lista = [];
                    let listaAbertos = [];

                    for (const itemAtivo of dados) {
                      if (itemAtivo?.id == thisProjeto?.id) {
                        lista.push({ ...itemAtivo, aberto: !itemAtivo?.aberto });

                        if (!itemAtivo?.aberto) {
                          listaAbertos.push({ ...itemAtivo, aberto: true });
                        }
                      } else {
                        lista.push(itemAtivo);
                      }
                    }

                    setDados(lista);
                    setDadosAbertos(listaAbertos);
                  }}
                >
                  <div className="top">
                    <div className="content-top">
                      <div className="card-top">
                        <p className="titulo">#{thisProjeto?.id} - {thisProjeto?.titulo}</p>
                        <p className="analista">{thisProjeto?.cliente?.nomeFantasia}</p>
                      </div>
                    </div>
                    <div className="content-progress">
                      <div className="card-content">
                        <p className="titulo">{thisProjeto?.horaUsada}h/{thisProjeto?.horaTotal}h</p>
                        <div className={"progress"}>
                          <ThisProgress backgound={thisProjeto?.horaUsada >= thisProjeto?.horaTotal ? "rgb(255 118 118)" : ((thisProjeto?.horaUsada * 100) / thisProjeto?.horaTotal) >= 80 ? "rgb(182 177 18)" : "#339C89"} width={((thisProjeto?.horaUsada * 100) / thisProjeto?.horaTotal) > 100 ? 100 : ((thisProjeto?.horaUsada * 100) / thisProjeto?.horaTotal) + "%"} />
                        </div>
                        <ThisButton
                          {...{ data: thisProjeto, linhaAtiva, setLinhaAtiva }}
                          key={thisProjeto?.id || i}
                        >
                          <img src={localStorage.getItem("tema") == "E" ? IconExcel : IconExcelB} alt="Icone de Excel" />
                        </ThisButton>
                      </div>
                      <div className="content-os">
                        <div className="info">
                          <div className="item-info">
                            <div className={thisProjeto?.idEtapa != 11 ? thisProjeto?.diasAtraso > 0 ? "estourado" : thisProjeto?.diasAtraso >= -10 ? "atraso" : "normal" : "normal"}></div>
                            <p className="data">Dias Atraso:{" " + thisProjeto?.diasAtraso < 0 ? 0 : thisProjeto?.diasAtraso}</p>
                          </div>
                          <div className="item-info">
                            <img src={localStorage.getItem("tema") == "E" ? IconProjEtapa : IconProjEtapaB} alt={"IconProjEtapa"} />
                            <p className="data">{thisProjeto?.etapa?.titulo}</p>
                          </div>
                          <div className="item-info">
                            <img src={localStorage.getItem("tema") == "E" ? IconProjCoord : IconProjCoordB} alt={"IconProjCoord"} />
                            <p className="data">{"Coord.: " + thisProjeto?.coordenador?.nome}</p>
                          </div>
                          <div className="item-info">
                            <img src={localStorage.getItem("tema") == "E" ? IconProjTempo : IconProjTempoB} alt={"IconProjTempo"} />
                            <p className="data">{"Total de Horas: " + thisProjeto?.horaTotal}h</p>
                          </div>
                          <div className="item-info">
                            <img src={localStorage.getItem("tema") == "E" ? IconProjData : IconProjDataB} alt={"IconProjData"} />
                            <p className="data">{"De " + ((new Date(thisProjeto?.previsaoInicio).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0] + " Até " + ((new Date(thisProjeto?.previsaoEntrega).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {thisProjeto?.aberto &&
                  <div className='card-subitem'>
                    <ThisCardItem cabecalho={true}>
                      <div className="col col3">
                        <p>Titulo</p>
                      </div>
                      <div className="col col1 center">
                        <p>Total</p>
                      </div>
                      <div className="col col1 center">
                        <p>Disponível</p>
                      </div>
                      <div className="col col1 center">
                        <p>Usada</p>
                      </div>
                      <div className="col col1 center">
                        <p>Prev. Inicio</p>
                      </div>
                      <div className="col col1 center">
                        <p>Prev. Final</p>
                      </div>
                      <div className="col col1 center">
                        <p>Dias Atraso</p>
                      </div>
                      <div className="col col1 center">
                        <p>Alt. Prev Entrega</p>
                      </div>
                      <div className="col col3-2">
                      </div>
                    </ThisCardItem>
                    {thisProjeto?.atividades?.map((thisAtiv, o) => (
                      <ThisCardItem>
                        <div className="col col3">
                          <p>{thisAtiv?.titulo}</p>
                        </div>
                        <div className="col col1 center">
                          <p>{thisAtiv?.horaTotal}</p>
                        </div>
                        <div className="col col1 center">
                          <p>{thisAtiv?.horaSaldo}</p>
                        </div>
                        <div className="col col1 center">
                          <p>{thisAtiv?.horaUsada}</p>
                        </div>
                        <div className="col col1 center">
                          <p>{((new Date(thisAtiv?.previsaoInicio).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                        </div>
                        <div className="col col1 center">
                          <p>{((new Date(thisAtiv?.previsaoEntrega).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                        </div>
                        <div className="col col1 center">
                          <p>{thisAtiv?.diasAtraso}</p>
                        </div>
                        <div className="col col1 center">
                          <p>{thisAtiv?.historicos?.length}</p>
                        </div>
                        <div className="col col3-2">
                          <div className="content-progress">
                            <div className="card-content">
                              <p className="titulo">{thisAtiv?.horaUsada}h/{thisAtiv?.horaTotal}h</p>
                              <div className="progress">
                                <ThisProgress backgound={thisAtiv?.horaUsada > thisAtiv?.horaTotal ? "rgb(255 118 118)" : ((thisAtiv?.horaUsada * 100) / thisAtiv?.horaTotal) >= 80 ? "rgb(182 177 18)" : "#339C89"} width={((thisAtiv?.horaUsada * 100) / thisAtiv?.horaTotal) > 100 ? 100 : ((thisAtiv?.horaUsada * 100) / thisAtiv?.horaTotal) + "%"} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </ThisCardItem>
                    ))}
                  </div>
                }
              </ThisCard>
            ))}
          </SectionProjeto>
        </ScrollOS>
      </div>
    </Container>
  );
}

export default CustomBodyContent;
